// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.css';
import VueFullscreen from 'vue-fullscreen';
// import colors from 'vuetify/es5/util/colors';

import '@/styles/main.styl';

import App from './App';
import router from './router';
import store from './store';

Vue.use(VueFullscreen);
Vue.use(Vuetify);
// Vue.use(Vuetify, {
//   theme: {
//     primary: '#4F8AFF',
//     secondary: colors.blue.darken3,    // #FFCDD2
    // accent: colors.blue,                    // #3F51B5
    // error: '#000',
    // info: '#000',
    // success: '#000',
    // warning: colors.orange.darken2,
  // },
// });

Vue.config.productionTip = false;

console.group('Versions');
console.log(`Using Vue: ${Vue.version}`);
console.log(`Using Vuetify: ${Vuetify.version}`);
console.groupEnd();

Vue.mixin({
  methods: {
    formatVariableName(name) {
      return name.replace(/_/g, ' ').toUpperCase();
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js